import {createContext} from 'react';

const cyContext = createContext({});

export default cyContext;
